import * as types from 'store/modules/hres88e/mutation-types'
import hres88e from 'api/hres88e'
import swal from 'sweetalert'
import hres88eLabels from 'assets/labels/hres88e'
import { hres88eColumns } from 'assets/columns/hres88e'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres88eLabels,
    columns: hres88eColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      dtereq: '',
      numseq: '',
      codcomp: '',
      desc_codcomp: '',
      numreqst: '',
      codpos: '',
      desc_codpos: '',
      codjob: '',
      desc_codjob: '',
      codempmt: '',
      desc_codempmt: '',
      qtyreq: '',
      dtereqm: '',
      v_year: '',
      v_mth: '',
      amtincom: '',
      codrearq: '',
      type: '',
      v_syncond1: '',
      v_syncond: {
        code: '',
        description: ''
      },
      flgjob: '',
      flgcond: '',
      flgrecut: '',
      desnote: '',
      staappr: ''
    },
    dropdowns: {
      codrearq: {
        en: {},
        th: {}
      }
    },
    listFields: {
      en: [{}],
      th: [{}]
    },
    syncond1: {}
  },
  getters: {
    [types.GET_HRES88E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES88E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES88E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES88E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES88E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES88E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES88E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES88E_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRES88E_LOGICAL_LISTFIELDS] (state) {
      return state.listFields
    },
    [types.GET_HRES88E_DETAIL_CODJOB] (state) {
      return state.syncond1
    }
  },
  mutations: {
    [types.SET_HRES88E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES88E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES88E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES88E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES88E_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRES88E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES88E_DETAIL] (state, detail) {
      state.detail = detail
    },
    [types.SET_HRES88E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRES88E_LOGICAL_LISTFIELDS] (state, listFields) {
      state.listFields = listFields
    },
    [types.SET_HRES88E_DETAIL_CODJOB] (state, syncond1) {
      state.detail.v_syncond1 = syncond1
    }
  },
  actions: {
    [types.TOGGLE_HRES88E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES88E_INDEX_DISP, indexDisp)
      commit(types.SET_HRES88E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES88E_COLUMNS_LABELS] ({ commit }) {
      hres88e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES88E_COLUMNS, data.labels)
          commit(types.SET_HRES88E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES88E_INDEX] ({ commit }, searchParams) {
      hres88e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES88E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES88E_CREATE] ({ commit }, searchParams) {
      hres88e.getCreate(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          data.v_syncond = {
            code: '',
            description: ''
          }
          commit(types.SET_HRES88E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES88E_DETAIL] ({ commit }, searchParams) {
      hres88e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          data.v_syncond = {
            code: data.v_syncond,
            description: data.v_syncond_desc
          }
          commit(types.SET_HRES88E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES88E_DROPDOWNS] ({ commit }) {
      hres88e.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES88E_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES88E_LOGICAL_LISTFIELDS] ({ commit }, searchParams) {
      hres88e.getLogical()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES88E_LOGICAL_LISTFIELDS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES88E_DETAIL_CODJOB] ({ commit }, searchParams) {
      hres88e.getDetailCodjob(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES88E_DETAIL_CODJOB, data.syncond)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES88E_DETAIL_SAVE] ({ commit, dispatch }, { searchParams, detail }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres88e.postDetailSave({ searchParams, detail })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES88E_INDEX, searchParams)
              dispatch(types.RECEIVED_HRES88E_DETAIL, searchParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRES88E_CANCEL] ({ commit, dispatch }, { sendParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres88e.postCancel(sendParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES88E_INDEX, searchParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres88e/index.js